import { useCallback } from "react";

export type Theme = "white" | "dark" | "gray" | "indigo";

export const useThemed = (theme: Theme = "white") =>
  useCallback(
    (map: Partial<Record<Theme, string>>, defaultValue?: string) => {
      return map[theme] || defaultValue;
    },
    [theme],
  );
